/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { Pipe, PipeTransform } from '@angular/core';
import { EmployeeGroupModel } from '../../models/employee-group.model';
import { EmployeeModel } from '../../models/employee.model';

@Pipe({
  name: 'employeeGroupSearch',
  standalone: false
})
export class EmployeeGroupSearchPipe implements PipeTransform {
  transform(
    employeeGroups: EmployeeGroupModel[] | undefined,
    searchTerm: string | undefined
  ): EmployeeGroupModel[] | null {
    if (!employeeGroups) {
      return null;
    }

    if (!searchTerm) {
      return employeeGroups;
    }

    const lowerCaseSearchTerm = searchTerm.toLowerCase();

    return employeeGroups.filter((group: EmployeeGroupModel) =>
      group.name?.toLowerCase().includes(lowerCaseSearchTerm)
    );
  }
}
